module.exports = __webpack_public_path__ + "media/stylesheets/images/media_ads-8760a23d83183b9e0fb8a5369202930c.png";